import {
  GetOfflineOrderGeneralDataChangesParams,
  OfflineOrderGeneralDataChanges,
} from './types/offlineOrderGeneralData.utils.types';

export const getOfflineOrderGeneralDataChanges = ({
  order,
  data,
}: GetOfflineOrderGeneralDataChangesParams): OfflineOrderGeneralDataChanges => ({
  shouldChangePriceTable: !!data.priceTableId && data.priceTableId !== order.priceTable.id,
  shouldChangeSalesRepresentative:
    'salesRepresentativeId' in data && data.salesRepresentativeId !== order.salesRepresentative?.id,
  shouldChangeSeller: 'sellerId' in data && data.sellerId !== order.seller?.id,
});
